import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { toast } from "../ui/sonner";
import { CalendarCheck, Loader2, ShieldCheck } from "lucide-react";

/* 完工待检 → 一键安排检查（公司 / 市政府检查日期）或「验收通过（跳过检查日期）」直接关闭里程碑 */
export const StageInspectDialog = ({ open, onClose, sc, m, api, zh, reload }) => {
  const [insp, setInsp] = useState({ companyInspection: m.companyInspection || "", municipalInspection: m.municipalInspection || "" });
  const [busy, setBusy] = useState("");
  const act = async (path, body, okMsg) => {
    setBusy(path);
    try { await api.post(`/subcontracts/${sc.id}/stages/${m.id}/${path}`, body || {}); toast.success(okMsg); reload?.(); onClose(); }
    catch (e) { toast.error(e?.response?.data?.detail || e.message); }
    setBusy("");
  };
  const save = () => {
    if (!insp.companyInspection && !insp.municipalInspection) { toast.error(zh ? "请至少填写一个检查日期" : "Enter at least one inspection date"); return; }
    act("inspections", insp, zh ? "检查已安排 · 已通知分包商" : "Inspection scheduled");
  };
  const nodes = m.taskNodes || [];
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="stage-inspect-dialog" data-ms={m.id}>
        <DialogHeader>
          <DialogTitle className="text-sm flex items-center gap-1.5"><CalendarCheck className="h-4 w-4 text-purple-600" />{zh ? "安排检查" : "Schedule inspection"}</DialogTitle>
          <DialogDescription className="text-[11px]" data-testid="stage-inspect-desc">{sc.address} · {sc.tradeName} · <span className="font-semibold text-slate-700">{m.name}</span></DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-xs">
          <div className="rounded-lg bg-purple-50 border border-purple-100 px-3 py-2 text-[11px] text-purple-800" data-testid="stage-inspect-linked" data-count={nodes.length}>
            {nodes.length > 0
              ? (zh ? `完成条件任务 ${nodes.length} 个已全部完成${m.stageAutoCompleted ? "（自动进入完工待检）" : ""}：` : `${nodes.length} linked task(s) complete: `) + nodes.join("、")
              : (zh ? "该里程碑未绑定完成条件任务；分包商已报完工。" : "No linked tasks; subcontractor reported completion.")}
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-[10px] text-slate-500 block mb-0.5">{zh ? "公司检查日期" : "Company inspection"}</label>
              <input data-testid={`stage-company-${m.id}`} type="date" value={insp.companyInspection} onChange={(e) => setInsp((x) => ({ ...x, companyInspection: e.target.value }))} className="h-8 w-full text-xs border border-slate-200 rounded px-2" />
            </div>
            <div>
              <label className="text-[10px] text-red-500 block mb-0.5">{zh ? "市政府检查日期" : "Municipal inspection"}</label>
              <input data-testid={`stage-municipal-${m.id}`} type="date" value={insp.municipalInspection} onChange={(e) => setInsp((x) => ({ ...x, municipalInspection: e.target.value }))} className="h-8 w-full text-xs border border-red-200 rounded px-2" />
            </div>
          </div>
          <p className="text-[10px] text-slate-400">{zh ? "保存后里程碑进入「检查中」并通知分包商；检查日期会出现在周检查日历。无需检查可直接「验收通过」。" : "Saving sets the stage to Inspecting and notifies the subcontractor. Skip dates to pass directly."}</p>
          <div className="flex items-center justify-between gap-2 pt-1 flex-wrap">
            <Button size="sm" variant="outline" onClick={onClose} disabled={!!busy} data-testid="stage-inspect-cancel">{zh ? "取消" : "Cancel"}</Button>
            <div className="flex items-center gap-2">
              <Button size="sm" className="h-8 bg-green-600 hover:bg-green-700 text-white" disabled={!!busy} onClick={() => act("close", {}, zh ? "验收通过 ✓ 关联任务已自动完成" : "Accepted")} data-testid={`stage-inspect-pass-${m.id}`}>
                {busy === "close" ? <Loader2 className="h-3.5 w-3.5 animate-spin mr-1" /> : <ShieldCheck className="h-3.5 w-3.5 mr-1" />}{zh ? "验收通过（跳过检查日期）" : "Pass (skip dates)"}
              </Button>
              <Button size="sm" className="h-8 bg-brand-500 hover:bg-brand-600 text-white" disabled={!!busy} onClick={save} data-testid={`stage-inspect-save-${m.id}`}>
                {busy === "inspections" ? <Loader2 className="h-3.5 w-3.5 animate-spin mr-1" /> : <CalendarCheck className="h-3.5 w-3.5 mr-1" />}{zh ? "保存检查日期" : "Save dates"}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
